import { render, staticRenderFns } from "./MunicipalitySelectionDeleteButton.vue?vue&type=template&id=8fcf8e80&scoped=true&"
import script from "./MunicipalitySelectionDeleteButton.vue?vue&type=script&lang=ts&"
export * from "./MunicipalitySelectionDeleteButton.vue?vue&type=script&lang=ts&"
import style0 from "./MunicipalitySelectionDeleteButton.vue?vue&type=style&index=0&id=8fcf8e80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fcf8e80",
  null
  
)

export default component.exports